module.exports = __webpack_public_path__ + "img/sbflogo_v3.eb2824eb.svg";